import React, { useState } from 'react';
import TextField, { BaseTextFieldProps } from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import useCookie from '../../_hook/useCookie';
import { COOKIE_KEY } from '../../constant/cookie';
import InputTranslationLanguageSelect from './_module/InputTranslationLanguageSelect';

interface IProps {
  values: {
    la: string;
    text: string;
  }[];
  onChange: (
    values: {
      la: string;
      text: string;
    }[]
  ) => void;
  label?: string;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  variant?: BaseTextFieldProps['variant'];
}

const useStyles = makeStyles<Theme, IProps>((theme) => ({
  textareaTextField: { borderRadius: 0 },
  textarea: {
    backgroundColor: theme.palette.mode === 'light' ? '#f3f3f3' : 'inherit',
  },
}));

export default function InputTranslationTextarea(props: IProps) {
  const {
    values,
    onChange: propOnChange,
    label,
    required,
    fullWidth,
    error,
    helperText,
    variant,
  } = props;
  const classes = useStyles(props);
  const { cookies } = useCookie([COOKIE_KEY.LANGUAGE]);
  const [language, setLanguage] = useState<any>(cookies[COOKIE_KEY.LANGUAGE]);

  function onChange(newValue: string) {
    let newValues = [...values];

    if (values && values.find((propValue) => propValue.la === language)) {
      newValues = newValues.map((item) => {
        if (item.la === language) {
          item.text = newValue;
        }
        return item;
      });
    } else {
      newValues.push({
        la: language,
        text: newValue,
      });
    }

    if (propOnChange) {
      propOnChange(newValues);
    }
  }

  let currentValue = values.find((item) => item.la === language);

  if (!currentValue) {
    currentValue = {
      la: language,
      text: '',
    };
  }

  return (
    <div>
      <Typography variant="body1">{label}</Typography>
      <FormControl variant="outlined" fullWidth size="small">
        <InputTranslationLanguageSelect
          language={language}
          type="textarea"
          variant="outlined"
          onChange={setLanguage}
        />
      </FormControl>
      <TextField
        className={classes.textarea}
        InputProps={{ className: classes.textareaTextField }}
        required={required}
        fullWidth={fullWidth}
        multiline
        rows="5"
        value={currentValue.text}
        onChange={(evt) => {
          onChange(evt.target.value);
        }}
        error={error}
        helperText={helperText}
        variant={variant}
      />
    </div>
  );
}
